import React, { useState, useEffect, useRef } from "react";
import { config } from "../../../utils/config";
import {
  XMarkIcon,
  ArrowTopRightOnSquareIcon,
} from "@heroicons/react/24/outline";
import { disabledIfFieldChecker } from "../../../utils/helperFuctions";
function InputFileSingle({
  label,
  name,
  id,
  defaultValue,
  handleChange,
  handleDeleteFiles,
  required,
  disabled,
  currentFields,
  disabledIfField,
}) {
  const inputRef = useRef();
  const [previewImage, setPreviewImage] = useState(() => {
    if (defaultValue instanceof FileList) {
      if (defaultValue.length > 0) {
        // Handle defaultValue as a FileList
        if (defaultValue[0].type && defaultValue[0].type.match("image.*")) {
          return URL.createObjectURL(defaultValue[0]);
        } else {
          return "/free-file-icon-1453-thumb.png";
        }
      } else {
        return "/no-result-data-document-or-file-not-found-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-etc-vector.jpg";
      }
    }
    return defaultValue
      ? Array.isArray(defaultValue) && defaultValue.length > 0
        ? defaultValue[0].type?.match("image.*")
          ? `${config.apiUrl}/assets/${defaultValue[0].name ?? defaultValue}`
          : "/free-file-icon-1453-thumb.png"
        : defaultValue.type?.match("image.*")
        ? `${config.apiUrl}/assets/${defaultValue.name ?? defaultValue}`
        : "/free-file-icon-1453-thumb.png"
      : "/no-result-data-document-or-file-not-found-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-etc-vector.jpg"; // Replace with the actual image URL
  });

  const [objectURL, setObjectURL] = useState(() => {
    if (defaultValue instanceof FileList) {
      if (defaultValue.length > 0) {
        // Handle defaultValue as a FileList
        return URL.createObjectURL(defaultValue[0]);
      } else {
        return "/no-result-data-document-or-file-not-found-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-etc-vector.jpg";
      }
    }

    return defaultValue
      ? `${config.apiUrl}/assets/${defaultValue.name ?? defaultValue}`
      : "/no-result-data-document-or-file-not-found-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-etc-vector.jpg";
  });

  const [uploadedFile, setFile] = useState(() => {
    if (defaultValue instanceof FileList) {
      if (defaultValue.length > 0) {
        // Handle defaultValue as a FileList
        return defaultValue[0];
      }
    }
    return defaultValue;
  });

  const initial = {
    id: defaultValue?.id,
    name: defaultValue?.name,
  };

  const handleFileChange = (event) => {
    const input = event.target;
    const file = input.files[0];
    const megabytes = 5;
    // Set the maximum file size limit (in bytes)
    const maxFileSize = megabytes * 1024 * 1024; // 10 MB

    if (file?.size > maxFileSize) {
      alert(
        `File size exceeds the limit of ${megabytes}MB. Maximum ${megabytes}MB`
      );
      // Clear the file input
      event.target.value = "";
      return;
    }

    if (file) {
      const type = file.type;

      const newObjectURL = URL.createObjectURL(file);
      setObjectURL(newObjectURL);
      if (type.match("image.*")) {
        setPreviewImage(newObjectURL);
      } else {
        setPreviewImage("/free-file-icon-1453-thumb.png");
      }
    }
    if (objectURL?.includes("/assets/")) {
      handleDeleteFiles({
        name: initial.name,
        id: initial.id,
      });
    }
    setFile(file);

    handleChange(event);
  };

  useEffect(() => {
    return () => {
      // This function is called when the component is unmounted
      if (objectURL) {
        URL.revokeObjectURL(objectURL);
      }
    };
  }, [objectURL]);

  const openImagePreview = (e) => {
    // Open the preview image in a new window or tab
    if (e) e.preventDefault();

    window.open(objectURL);
  };

  const clearFile = () => {
    const tempObjUrl = objectURL;

    setFile(null);
    setObjectURL(null);
    setPreviewImage(null);

    if (tempObjUrl?.includes("/assets/")) {
      handleDeleteFiles({
        name: initial.name,
        id: initial.id,
      });
      handleChange({
        target: {
          name: name,
          value: "",
        },
      });
    } else {
      handleChange({
        target: {
          name: name,
          value: "",
        },
      });
    }

    inputRef.current.value = null;
  };
  const isFieldDisabled =
    disabledIfField != null
      ? disabled ||
        disabledIfFieldChecker(currentFields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabled ?? false;
  return (
    <>
      <label
        htmlFor={name}
        className="text-left block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
        {required ? "*" : ""}
      </label>
      {/* <div className="flex items-center space-x-6">
      <div className="shrink-0">
        <img
          id="preview_img"
          className="h-16 w-16 object-cover rounded-full"
          src={previewImage}
          alt={`preview_img ${name}`}
          onClick={openImagePreview} // Add onClick event handler
        />
      </div>
      <label className="block">
        <span className="sr-only">Choose profile photo</span>
        <input
          type="file"
          onChange={handleFileChange}
          name={name}
          id={id}
          className="block w-full text-sm text-slate-500
            file:mr-4 file:py-2 file:px-4
            file:rounded-full file:border-0
            file:text-sm file:font-semibold
            file:bg-violet-50 file:text-primary
            hover:file:bg-violet-100"
        />
      </label>
    </div> */}
      <div className="flex flex-col items-center p-4 border rounded-lg shadow-sm">
        {uploadedFile && (
          <div className="relative w-32 h-32 mb-4">
            {isFieldDisabled != true && (
              <button
                onClick={clearFile}
                className="absolute top-0 right-0 p-1 bg-red-500 rounded-lg focus:outline-none"
              >
                <XMarkIcon className="w-4 h-4 text-white" />
              </button>
            )}
            <button
              onClick={openImagePreview}
              className="absolute bottom-0 left-0 p-1 bg-blue-700 rounded-lg focus:outline-none"
            >
              <ArrowTopRightOnSquareIcon className="w-6 h-6 text-white" />
            </button>
            <img
              src={previewImage}
              alt={`preview_img ${name}`}
              className="object-cover w-full h-full rounded-lg"
              onClick={openImagePreview}
            />
          </div>
        )}
        {isFieldDisabled !== true && (
          <label
            onClick={(e) => {
              if (isFieldDisabled === true) {
                e.preventDefault();
                return;
              }
            }}
            style={{
              cursor: isFieldDisabled === true ? "not-allowed" : "pointer",
            }}
            className="px-4 py-2 text-white bg-blue-600 rounded cursor-pointer hover:bg-blue-500"
          >
            Upload File
            <input
              onClick={(e) => {
                if (isFieldDisabled === true) {
                  e.preventDefault();
                  return;
                }
              }}
              type="file"
              className="hidden"
              name={name}
              id={id}
              ref={inputRef}
              onChange={(e) => {
                if (isFieldDisabled === true) return;
                handleFileChange(e);
              }}
            />
          </label>
        )}
      </div>
    </>
  );
}

export default InputFileSingle;
